import script from "./ModalPayment.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalPayment.vue?vue&type=script&lang=ts&setup=true"

import "./ModalPayment.vue?vue&type=style&index=0&id=6746dfcf&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6746dfcf"]])

export default __exports__